import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FieldAgentClient, BisTrackUser } from 'ep-bt-field-agent-proxy';
import { EpbtFaNotepadService } from '../../services/epbt-fa-notepad.service'

@Component({
    selector: 'epbt-fa-bistrackuser-list',
    templateUrl: './epbt-fa-bistrackuser-list.component.html',
    styleUrls: ['./epbt-fa-bistrackuser-list.component.scss']
})
export class EpbtFaBistrackuserListComponent implements OnInit, AfterViewInit {
    // ngAfterViewChecked(): void {
    //   // throw new Error("Method not implemented.");
    // }

    @Input() bistrackUsers: any[] = []
    @Input() disabled: boolean = false;
    @Input() isEditable: boolean = true;
    // private _selectedbistrackUser: BisTrackUser;
    // @Input('selectedbistrackUser') set selectedbistrackUser(value: BisTrackUser) {
    //   this._selectedbistrackUser = value;
    //   this.bistrackUserChange.emit(this._selectedbistrackUser);
    // }
    // get selectedbistrackUser(): BisTrackUser {
    //   return this._selectedbistrackUser;
    // }

    private _selectedbistrackUser: number;
    @Input('selectedbistrackUser') set selectedbistrackUser(value: number) {
        this._selectedbistrackUser = value;
        if (this._selectedbistrackUser) {
            var result = this.bistrackUsers.filter(x => x.userId == this._selectedbistrackUser);
            // if (this.notepadService.isCalendar) {

            // }
            this.bistrackUserChange.emit(result ? result[0] : null);
        }
    }
    get selectedbistrackUser(): number {
        return this._selectedbistrackUser;
    }

    @Output() bistrackUserChange = new EventEmitter<any>();

    @Input() labelText: string = "";

    constructor(private client: FieldAgentClient, private notepadService: EpbtFaNotepadService, ) { }

    ngOnInit() {
        this.GetBistrackUsers();
    }

    ngAfterViewInit() {
        // this.GetBistrackUsers();
    }

    onSelectionChange(selectedValue: any) {
        if (selectedValue) {
            // this.selectedbistrackUser = selectedValue;
            // this.bistrackUserChange.emit(this.selectedbistrackUser);
            // console.log("EpbtFaBistrackuserListComponent - onSelectionChange - Start");
            this.selectedbistrackUser = selectedValue.userId;
            var result = this.bistrackUsers.filter(x => x.userId == this.selectedbistrackUser);
            this.bistrackUserChange.emit(result ? result[0] : null);
            // console.log("EpbtFaBistrackuserListComponent - onSelectionChange - End");
        }
    }

    async GetBistrackUsers() {
        this.client.getBisTrackUsers().subscribe(res => {
            this.bistrackUsers = res;
            if (this._selectedbistrackUser) {
                var result = this.bistrackUsers.filter(x => x.userId == this._selectedbistrackUser);
                this.bistrackUserChange.emit(result ? result[0] : null);
            }
            else {
                this.selectedbistrackUser = this.bistrackUsers[0].userId;
                this.bistrackUserChange.emit(this.bistrackUsers[0]);
            }
            // console.log("EpbtFaBistrackuserListComponent - GetBistrackUsers");
            // console.log(res);
        });
    }
}
